import React from "react";

export default function CustomCard({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={`p-6 border-extra-light border bg-white rounded-md ${className}`}
    >
      {children}
    </div>
  );
}
